import styled from 'styled-components'
import ImageCustom from '../ImageCustom'


export const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  width: 320px;
  gap: 8px;
  align-items: flex-start;
  justify-content: center;

  @media (min-width: ${props => props.theme.mediaQuery.smallpc}) {
    width: 524px;
  }

  @media (max-width: ${props => props.theme.mediaQuery.mobile}) {
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }

`
export const Tag = styled.div<{ hasIcon?: boolean }>`
  background-color: rgba(255, 255, 255, 0.82);
  border-radius: 16px;
  padding: 4px 16px 4px ${props => props.hasIcon ? '8px' : '16px'};
  display: flex;
  align-items: center;
  text-align: center;
`

export const Icon = styled( ImageCustom )`
  width: 16px;
  height: 16px;
  margin: 0 6px 0 0;
`
